import { BodySmallRegular, BodyLarge, BodyMedium } from '@/components/typography';

interface StatCardProps {
    platform: string;
    stat: string;
    link: string;
    glowColor: string;
    logoImage: string;
}

export function StatCard({ platform, stat, link, glowColor, logoImage }: StatCardProps) {
    return (
        <div className="col-span-1 flex flex-col justify-between items-start p-4 lg:p-6 min-h-[132px] lg:h-52 relative bg-gradient-to-br from-white/20 to-white/5 rounded-3xl shadow-[0px_0.9585345387458801px_23.963363647460938px_0px_rgba(69,42,124,0.10)] border-2 border-white/10 backdrop-blur-xl overflow-hidden">
            {/* oversized platform logo */}
            <img src={logoImage} alt={`${platform} platform logo`} className='absolute z-0 -bottom-4 -right-4 lg:-right-10' />
            {/* Glow effect */}
            <div 
                className={`absolute w-full h-full left-[110px] top-[98px] opacity-60 rounded-full blur-[95px] z-10`}
                style={{ backgroundColor: glowColor }}
            />
            
            {/* Content */}
            <div className="flex flex-col justify-end items-start gap-1 relative z-20">
                <BodySmallRegular className="text-white/60">
                    {platform}
                </BodySmallRegular>
                <BodyLarge className="text-white">
                    {stat}
                </BodyLarge>
            </div>
            
            <div className="">
                <BodyMedium className="text-primary">
                    {link}
                </BodyMedium>
            </div>
        </div>
    );
}